/**
 * heatmapGenerator.js
 * Skrypt do generowania heatmapy dla tabel statystycznych
 * z niestandardową kolorystyką (biały -> rozjaśniony #3077e3).
 */

function initializeHeatmaps(containerSelector) {
    const mainContainer = document.querySelector(containerSelector);
    if (!mainContainer) {
        // console.log('Kontener dla heatmapy nie został znaleziony:', containerSelector);
        return;
    }

    // Funkcja pomocnicza do parsowania stringa HSL na wartości liczbowe
    function hslStringToValues(hslStr) {
        if (typeof hslStr !== 'string' || !hslStr.toLowerCase().startsWith('hsl')) {
            return [0, 0, 100]; // Domyślnie dla białego tła (HSL_COLD)
        }
        const result = hslStr.match(/hsl\(\s*(\d+\.?\d*)\s*,\s*(\d+\.?\d*)%\s*,\s*(\d+\.?\d*)%\s*\)/i);
        if (result) {
            return [parseFloat(result[1]), parseFloat(result[2]), parseFloat(result[3])];
        }
        console.warn("Nie udało się sparsować stringa HSL:", hslStr);
        return [0, 0, 100]; // Fallback na biały
    }

    // Funkcja obliczająca kolor dla komórki heatmapy zgodnie z nową paletą
    function calculateHeatmapColor(value, min, max) {
        const H_HOT = 204;    // Barwa dla #3077e3
        const S_HOT = 76;     // Nasycenie dla #3077e3
        const L_HOT_ADJUSTED = 63.2; // Jasność dla #3077e3 rozjaśnionego o 20%

        const L_COLD = 100;   // Jasność dla białego (zimny kolor)
        // Dla białego nasycenie to 0%, ale aby uzyskać płynne przejście do koloru nasyconego,
        // będziemy interpolować również nasycenie od 0% do S_HOT.

        if (max === min) {
            // Jeśli wszystkie wartości są takie same, użyj "najzimniejszego" koloru (białego)
            // lub bardzo jasnego odcienia koloru docelowego.
            return `hsl(${H_HOT}, ${S_HOT}%, 95%)`; // Bardzo jasny odcień niebieskiego (prawie biały)
            // Alternatywnie: return 'hsl(0, 0%, 100%)'; // Czysty biały
        }

        const normalized = (value - min) / (max - min); // Normalizacja wartości do przedziału 0-1

        // Interpolacja Jasności: od L_COLD (100%) do L_HOT_ADJUSTED (63.2%)
        const lightness = L_COLD - (normalized * (L_COLD - L_HOT_ADJUSTED));

        // Interpolacja Nasycenia: od 0% (dla białego) do S_HOT (76%)
        // Chcemy, aby biel była czystą bielą (S=0), a najmocniejszy kolor miał pełne nasycenie.
        const saturation = normalized * S_HOT;

        return `hsl(${H_HOT}, ${saturation.toFixed(1)}%, ${lightness.toFixed(1)}%)`;
    }

    function processTableForHeatmap(tableElement) {
        const dataCellsInfo = [];
        let numericValues = [];

        const rows = tableElement.querySelectorAll('tr');
        rows.forEach((row, rowIndex) => {
            if (rowIndex === 0) return;

            const cells = row.querySelectorAll('td');
            cells.forEach((cell, cellIndex) => {
                if (cellIndex === 0) return;

                const linkElement = cell.querySelector('a');
                if (linkElement) {
                    const valueString = linkElement.textContent.trim().replace(/\s/g, '');
                    const value = parseFloat(valueString);
                    if (!isNaN(value)) {
                        dataCellsInfo.push({ tdElement: cell, value: value, linkElement: linkElement });
                        numericValues.push(value);
                    }
                }
            });
        });

        if (numericValues.length === 0) return;

        const minValue = Math.min(...numericValues);
        const maxValue = Math.max(...numericValues);

        dataCellsInfo.forEach(cellInfo => {
            const bgColor = calculateHeatmapColor(cellInfo.value, minValue, maxValue);
            cellInfo.tdElement.style.backgroundColor = bgColor;
            cellInfo.tdElement.classList.add('heatmap-cell-processed');

            // Dostosowanie koloru tekstu w linku
            const [h, s, l] = hslStringToValues(bgColor);

            // Dla tej palety (biały -> jasnoniebieski), tekst prawie zawsze powinien być ciemny.
            // Jasność tła będzie w zakresie [63.2%, 100%].
            // Próg można ustawić wysoko, np. jeśli jasność jest bardzo bliska 100%.
            if (l > 90) { // Jeśli tło jest bardzo jasne (prawie białe)
                cellInfo.linkElement.style.color = 'black'; // lub np. '#333'
            } else {
                // Dla kolorów HSL(204, S_interpolowane, L_interpolowane > 63%)
                // czarny tekst powinien być zazwyczaj czytelny.
                // Możesz przetestować kontrast i ewentualnie zmienić na biały dla najmocniejszych odcieni,
                // ale L=63.2% zazwyczaj jeszcze dobrze kontrastuje z czarnym.
                cellInfo.linkElement.style.color = 'black';
            }
            cellInfo.linkElement.style.fontWeight = 300;
        });
    }

    const tablesToHeatmap = mainContainer.querySelectorAll('.table-scrollable table');
    if (tablesToHeatmap.length > 0) {
        tablesToHeatmap.forEach(table => {
            processTableForHeatmap(table);
        });
    }
}

// Uruchom inicjalizację po załadowaniu DOM
document.addEventListener('DOMContentLoaded', function() {
    initializeHeatmaps('.stats-matrix'); // Użyj swojej głównej klasy kontenera
});

// Jeśli używasz Webpack i chcesz wyeksportować funkcję:
// export { initializeHeatmaps };